/* unplugin-vue-components disabled */import { render } from "./playground.vue?vue&type=template&id=e5e3818a&scoped=true"
import script from "./playground.vue?vue&type=script&lang=js"
export * from "./playground.vue?vue&type=script&lang=js"

import "./playground.vue?vue&type=style&index=0&id=e5e3818a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5e3818a"],['__file',"src/pages/playground/playground.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5e3818a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5e3818a', __exports__)) {
    api.reload('e5e3818a', __exports__)
  }
  
  module.hot.accept("./playground.vue?vue&type=template&id=e5e3818a&scoped=true", () => {
    api.rerender('e5e3818a', render)
  })

}


export default __exports__